import { ResponsibleType } from '@/ui/modules/admin/views/Responsibles/responsibleType'

import { axios, Response } from '../index'

export type CreateAssignResponsibleDTO = {
  cpf: string
  email: string
  name: string
  lastName: string
  responsibleType: ResponsibleType
}

export default async function assignResponsible(
  patientId: string,
  data: CreateAssignResponsibleDTO
): Response<void> {
  return await axios.post(`/v1/patients/${patientId}/responsible`, data)
}
